import authService from "src/helpers/authService";
import { User } from "src/store/User"

export const RouteName = "attendance-tracker"

export function authZ_hasSomeRoutePermission() : boolean {
  const hasSomeRole = authService(User.userData?.roles ?? [], "registrar", "inLeague")
  const hasSomeCoachAssignment : boolean = !!User.userData?.coachAssignmentsMemento.find(v => v.title === "Head Coach" || v.title === "Co-Coach");
  return hasSomeRole || hasSomeCoachAssignment
}
